/* eslint-disable */
import axios from "axios";

export default {
  namespaced: true,
  state: {
    token: "",
    user: {},
    company: {},
    roleName: "",
  },
  getters: {
    authenticated(state) {
      return state.token ? true : false;
    },
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    roleName(state) {
      return state.user && state.user.roles && state.user.roles[0] ? state.user.roles[0].name : '';
    },
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
    },
    SET_USER(state, data) {
      state.user = data;
      let userCompanies = data && data.companies ? data.companies : [];
      state.company = userCompanies.length ? userCompanies[0] : {};
    },
    SET_COMPANY(state, company) {
      state.company = company;
      axios.defaults.headers.common["company-id"] = company.id;
    },
  },
  actions: {
    async logIn({ dispatch }, credentials) {
      try {
        console.log('Auth store: Attempting login...');
        const response = await axios.post("/login", credentials);

        if (response.data && response.data.token) {
          console.log('Auth store: Login successful, setting token...');
          await dispatch("attempt", response.data.token);

          // Store auth token for auto-sync (only in Electron)
          if (window.electron && response.data.token) {
            try {
              await window.electron.storeAuthToken(response.data.token);
              console.log('Auth store: Token stored for auto-sync');
            } catch (e) {
              console.warn('Auth store: Failed to store token for auto-sync:', e);
            }
          }

          console.log('Auth store: Login flow completed');
        } else {
          throw new Error('No token received from login response');
        }
      } catch (error) {
        console.error('Auth store: Login failed:', error);
        throw error; // Re-throw to let login component handle it
      }
    },
    async attempt({ state, commit }, token) {
      console.log('Auth store: Attempting authentication with token:', !!token);

      if (token) {
        commit("SET_TOKEN", token);
      }

      if (!state.token) {
        console.log('Auth store: No token available');
        return Promise.resolve();
      }

      try {
        console.log('Auth store: Fetching user data...');
        const response = await axios.get("/me");

        if (response.data && response.data.data) {
          console.log('Auth store: User data received:', response.data.data.email);
          commit("SET_USER", response.data.data);

          // Store user in localStorage for offline services (user-data-service.js)
          localStorage.setItem('user', JSON.stringify(response.data.data));

          console.log('Auth store: Authentication attempt successful');
        } else {
          throw new Error('Invalid user data received');
        }
      } catch (error) {
        console.error('Auth store: Failed to fetch user data:', error);
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        throw error;
      }
    },
    async logOut({ commit }) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);

      // Clear localStorage items
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('setup_complete');
      localStorage.removeItem('app_mode');
      localStorage.removeItem('master_ip');

      // Clear auth token for auto-sync (only in Electron)
      if (window.electron) {
        try {
          await window.electron.clearAuthToken();
          console.log('Auth store: Token cleared for auto-sync');
        } catch (e) {
          console.warn('Auth store: Failed to clear token for auto-sync:', e);
        }
      }
    },
    setCompany({ commit }, company) {
      commit("SET_COMPANY", company);
    },
  },
};
